import APIClient from './index';

export const getAllCalls = (params = {}) =>
  new Promise((resolve, reject) =>
    APIClient.get(`/chats?${new URLSearchParams(params).toString()}`)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error?.response?.data))
  );

export const getCall = (idOrHash) =>
  new Promise((resolve, reject) =>
    APIClient.get(typeof idOrHash === 'string' ? `/chats/shared/${idOrHash}` : `/chats/${idOrHash}`)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error?.response?.data))
  );

export const deleteCall = (call) =>
  new Promise((resolve, reject) =>
    APIClient.delete(`/chats/${call.id}`)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error?.response?.data))
  );

export const updateCall = (call, updates) =>
  new Promise((resolve, reject) =>
    APIClient.patch(`/chats/${call.id}`, updates)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error?.response?.data))
  );

export const regenerateSummary = (call) =>
  new Promise((resolve, reject) =>
    APIClient.put(`/chats/${call.id}/regenerate-summary`, {})
      .then((response) => resolve(response.data))
      .catch((error) => reject(error?.response?.data))
  );

export const reprocessCall = (call) =>
  new Promise((resolve, reject) =>
    APIClient.put(`/chats/${call.id}/reprocess`, {})
      .then((response) => resolve(response.data))
      .catch((error) => reject(error?.response?.data))
  );

export const updateChatParticipant = (participant, updates) =>
  new Promise((resolve, reject) =>
    APIClient.patch(`/chat-participants/${participant.id}`, updates)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error?.response?.data))
  );
